<template>
  <v-layout row justify-center v-show="isLoading" fill-height>
    <v-container fill-height>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-progress-circular
              color="primary"
              size="60"
              :indeterminate="isLoading"
          ></v-progress-circular>
        </v-col>
        <v-col cols="12" class="text-center">
          <p class="greyMedium--text">{{ loaderMsg }}</p>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>
<script>
export default {
  name: "FullHeightRadialLoader",
  props: {
    isLoading: Boolean,
    loaderMsg: String
  }
}
</script>